module.exports = __webpack_public_path__ + "static/media/3.fc274141.jpg";